// extracted by mini-css-extract-plugin
export default {"footerCol":"Footer_footerCol__zjQUX"};